import { Round } from '../interfaces';

export const getCurrentRounds = (rounds: Round[], round: number) =>
  rounds.filter(item => item.roundNumber === round);
